import React from "react";
import { FiExternalLink } from "react-icons/fi";
import styles from "./style.module.scss";
import { MutateResetProcessedWinTAXVars } from "../../../utils/graphql/hooks/adminHooks";
import { toast } from "react-hot-toast";

export default function WinTAXResetControls() {
  const resetProcessedWinTAXVars = MutateResetProcessedWinTAXVars();

  const carLabel = { redCar: "Red Car", blueCar: "Blue Car" };

  const handleReset = async (carType: "redCar" | "blueCar") => {
    try {
      const response = await resetProcessedWinTAXVars({
        variables: {
          cars: [{ carType, resetSessionEnergyCharged: true }],
        },
      });

      if (response.data?.resetProcessedWinTAXVars?.success) {
        toast.success(`${carLabel[carType]} reset successfully`);
      } else {
        toast.error(
          response.data?.resetProcessedWinTAXVars?.message ?? "Reset failed",
        );
      }
    } catch (error) {
      toast.error(error instanceof Error ? error.message : "Reset failed");
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        WinTAX Energy Reset{" "}
        <button
          className={styles.pageLink}
          onClick={() => window.open("/wintax-summary", "_blank")}
        >
          <FiExternalLink />
        </button>
      </div>
      <div className={styles.controls}>
        <button
          className={`${styles.actionButton} ${styles.redButton}`}
          onClick={() => handleReset("redCar")}
        >
          Reset Red Car
        </button>
        <button
          className={`${styles.actionButton} ${styles.blueButton}`}
          onClick={() => handleReset("blueCar")}
        >
          Reset Blue Car
        </button>
      </div>
    </div>
  );
}
